import { Box } from '@mui/material';
import {
  DialogBody,
  DialogContainer,
  DialogTitle,
} from '../../../common/components';

const AgreementViewerDialog = ({ open, title, fileUrl, onClose }) => (
  <DialogContainer
    open={open}
    onClose={onClose}
    size="large"
    minHeight="80vh"
  >
    <DialogTitle>Acuerdo vigente - {title}</DialogTitle>
    <DialogBody sx={{ minHeight: '75vh' }}>
      {fileUrl ? (
        <Box
          component="iframe"
          title="Vista archivo acuerdo vigente"
          src={fileUrl}
          width="100%"
          height="100%"
          sx={{ border: 0, minHeight: '72vh' }}
        />
      ) : null}
    </DialogBody>
  </DialogContainer>
);

export default AgreementViewerDialog;
